import React, { useContext } from "react";
import { Link } from "react-router-dom";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// Styles
import styles from "./DashboardHeader.module.css";

// images
import searchIcon from "../../../assets/img/DashboardICons/Search.svg";
import notifIcon from "../../../assets/img/DashboardICons/Notificiation.svg";
import arrowLeft from "../../../assets/img/DashboardICons/ArrowLeft.svg";
import { PanelLeftClose } from "lucide-react";

const DashboardHeader = props => {
  const { userData, consultantData } = useContext(UserContext);

  return (
    <>
      <div className={`py-2 mt-md-0 mt-5 ${props.class}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-2" dir="rtl">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}>
              <button
                style={{
                  display: props.isShowSidebar === false ? "block" : "none",
                }}
                onClick={() => props.setIsShowSidebar(true)}>
                <PanelLeftClose size={30} color="#363636" />
              </button>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  props.searchHandler();
                }}
                className={`d-flex align-items-center justify-content-center ${styles.searchbox_container}`}>
                <input
                  className={styles.searchbox}
                  type="text"
                  value={props.query}
                  onChange={props.placesFiles ? queryHandler : e => props.setQuery(e.target.value || "")}
                  placeholder="جستجو برای..."
                />
                <img className={styles.searchbox_icon} src={searchIcon} alt="icon" onClick={props.searchHandler} />
              </form>
            </div>
            <div className={`d-flex align-items-center justify-content-center ${styles.user_information_container}`}>
              <Link to="/notification" className={`d-flex align-items-center justify-content-center ms-4 ${styles.notif_container}`}>
                <img src={notifIcon} alt="icon" />
              </Link>

              <div className={`d-flex align-items-center justify-content-between ms-2 ${styles.notif_users_container}`} onClick={props.onClick}>
                <div className="d-flex align-items-center justify-content-center" onClick={() => props.setState(true)}>
                  <img
                    className={styles.user_img}
                    loading="lazy"
                    src={`https://backdev.azrmelk.com/images/users/avatar/${consultantData?.imageUrl?.replace("images/users/avatar/", "") || "avatar.png"}`}
                    alt="user-profile"
                  />
                  <div className={`d-flex align-items-start justify-content-center flex-column ${styles.users_name_info_container}`} dir="rtl">
                    <div className={styles.text1}>{userData.fullName}</div>
                    <div className={styles.text2}></div>
                  </div>
                </div>
                <img className={`ms-4 ${styles.arrow_icon}`} src={arrowLeft} alt="icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  function submitHandler(e) {
    e.preventDefault();
  }

  function queryHandler(query) {
    props.setQuery(prev => {
      return { ...prev, query: query || "" };
    });
  }
};

export default DashboardHeader;
